import { styled, alpha } from "@mui/material";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

export const ContainerBox = styled(Box)(({ theme }) => ({
  zIndex: theme.zIndex.modal + 1000,
  backgroundColor: alpha(theme.palette.primary.main, 0.95),
}));

export function TextBox({ children }: { children: string }) {
  return (
    <Box sx={{ pb: 3, maxWidth: 600 }}>
      <Typography variant="h1" gutterBottom>
        <Box component="span" sx={{ color: "common.white", fontWeight: "fontWeightRegular" }}>
          {children}
        </Box>
      </Typography>
    </Box>
  );
}
